// A bump is accept-or-decline, so a selection is always exactly one — same
// constant the card and the server's assertValidOrderBumpSubmission pin.
const BUMP_QUANTITY = 1;

/**
 * The order-bump form state a checkout opens with: every preselected placement
 * ticked, everything else absent.
 *
 * Twin of getVariantsFormFields for bumps, and used for the same reason — the
 * editor preview rebuilds this whenever the seller changes the placements, and
 * rebuilding it as `{}` wiped preselect (OrderBumps seeds in a CHILD effect,
 * which React runs before the parent doing the reset).
 *
 * Deliberately coarse: it reads the placement flags only, with no notion of
 * whether the offer resolves, is in stock, or passes its rule. OrderBumps'
 * own effect prunes anything that is not actually eligible, so an over-eager
 * tick here is corrected in the same commit rather than reaching a submission.
 */
export default function getOrderBumpsFormState(entries) {
  return Object.fromEntries(
    (entries ?? [])
      .filter(entry => entry?.preselected === true && entry?.enabled !== false)
      .map(entry => [String(entry.productId?._id ?? entry.productId), BUMP_QUANTITY]),
  );
}
